import { Icon } from '@wordpress/components';

import { chevronDown } from '@wordpress/icons';
import classnames from 'classnames';

import './styles.scss';

/**
 * Native HTML Accordion Component
 *
 * @param {Object}      props             Component props The component props
 * @param {JSX.Element} props.children    Accordion children
 * @param {string}      props.title       Accordion title
 * @param {string}      props.className   Accordion class name
 * @param {boolean}     props.defaultOpen Default open state
 *
 * @return {JSX.Element}                   Accordion component
 */
const Accordion = ({ children, title, className, defaultOpen }) => (
  <details className={classnames('mediapress-accordion', className)} open={defaultOpen}>
    <summary className="mediapress-accordion__summary">
      <span>{title}</span>
      <Icon className="mediapress-accordion__summary__icon" icon={chevronDown} />
    </summary>
    <div className="mediapress-accordion__content">{children}</div>
  </details>
);

export default Accordion;
